// extracted by mini-css-extract-plugin
export default {"vertical-icon":"styles_vertical-icon__TDCgy","card-link":"styles_card-link__y3Faq"};